import React from "react";
import { useLang } from "../../lib/LanguageContext";
import SectionHeading from "../SectionHeading";
import { GraduationCap, BookOpen, Rocket, Compass } from "lucide-react";

const ICONS = {
    workshop: GraduationCap,
    resource: BookOpen,
    apply: Rocket,
    guidance: Compass,
};

export default function Offerings() {
    const { t } = useLang();
    return (
        <section
            id="offerings"
            className="relative py-20 sm:py-24 md:py-32 border-t border-[color:var(--sau-border)]"
            data-testid="sau-offerings"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
                <div className="max-w-3xl">
                    <SectionHeading eyebrow={t.offerings.eyebrow} title={t.offerings.title} />
                    <p className="sau-reveal mt-5 sm:mt-6 text-[15px] sm:text-base md:text-lg text-[color:var(--sau-text-2)] leading-relaxed">
                        {t.offerings.intro}
                    </p>
                </div>

                <div className="mt-10 sm:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
                    {t.offerings.items.map((it, i) => {
                        const Icon = ICONS[it.icon] || BookOpen;
                        return (
                            <article
                                key={`offer-${i}`}
                                className="sau-reveal sau-card rounded-2xl p-7 h-full group"
                                data-testid={`sau-offering-${i}`}
                            >
                                <div className="w-11 h-11 rounded-xl flex items-center justify-center border border-[color:var(--sau-border)] bg-[#0B1A2B] group-hover:border-[color:var(--sau-accent)]/60 transition-colors">
                                    <Icon className="w-5 h-5 text-[color:var(--sau-accent)]" />
                                </div>
                                <h3 className="mt-5 text-lg font-semibold text-[color:var(--sau-text)]">{it.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-[color:var(--sau-text-2)]">{it.body}</p>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
